import React from 'react';
import { Box, Fab, Tooltip } from '@mui/material';
import { Add, Remove, MyLocation, Info } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../i18n';

const MapControls = ({ onLocateMe, onZoomIn, onZoomOut, onInfoToggle }) => {
  const { language } = useSelector((state) => state.ui);
  const translations = getTranslation(language);
  const t = translations.map.controls;

  return (
    <Box 
      className="map-controls"
      sx={{
        position: 'absolute',
        right: 16,
        bottom: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Tooltip title={t.zoomIn} placement="left">
        <Fab 
          size="small" 
          color="default" 
          aria-label={t.zoomIn}
          onClick={onZoomIn}
          sx={{ bgcolor: 'background.paper' }}
        >
          <Add />
        </Fab>
      </Tooltip>

      <Tooltip title={t.zoomOut} placement="left">
        <Fab 
          size="small" 
          color="default" 
          aria-label={t.zoomOut}
          onClick={onZoomOut}
          sx={{ bgcolor: 'background.paper' }}
        >
          <Remove />
        </Fab>
      </Tooltip>

      <Tooltip title={t.myLocation} placement="left">
        <Fab 
          size="small" 
          color="default" 
          aria-label={t.myLocation}
          onClick={onLocateMe}
          sx={{ bgcolor: 'background.paper' }}
        >
          <MyLocation />
        </Fab>
      </Tooltip>

      <Tooltip title={t.info} placement="left">
        <Fab 
          size="small" 
          color="default" 
          aria-label={t.info}
          onClick={onInfoToggle}
          sx={{ bgcolor: 'background.paper' }}
        >
          <Info />
        </Fab>
      </Tooltip>
    </Box>
  );
};

export default MapControls;
